<template lang="pug">
div
  .mt-8
    .text-xl.font-semibold.mb-3 Match column labels to customers information
    .mb-10
      span.font-bold {{ data.total_column }} 
      span {{ data.total_column > 1 ? 'columns' : 'column' }} have been recognized in this file
    v-data-table(
      :headers="headers"
      :items="items"
      :items-per-page="items.length"
      hide-default-footer
      disable-sort
    )
      template(v-slot:no-data)
        div
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:item.checked="{ item }")
        yc-checkbox(v-model="item.checked" @change="onChecked")
      template(v-slot:item.field="{ item }")
        .my-2
          custom-field-dropdown(:field.sync="item.field" :selectedFields="selectedFields")
      template(v-slot:item.type="{ item }")
        .my-2
          type-field-dropdown(
            :dataType="item.field && item.field.datatype" 
            :disabled="isTypeDisabled(item)"
          )
    .text-right.mt-4
      v-btn.button-Aa-large.px-6.round-lg(
        @click="finishMapping"
        color="info"
        depressed
        height=48
        :loading="isLoading"
        :disabled="isUncheckedAll"
      ) Finish mapping
  .dialogs
    y-dialog(
      v-if="showMapAllDialog"
      v-model="showMapAllDialog"
      max-width=568
      fluid
      scrollable
      content-class="round-2xl"
    )
      v-card
        v-card-text.pa-8.primary--text
          .text-xl.font-medium.mb-4 Please map all of the column that you want to import 
          .text-md You can choose to map it to a new field or an existing one.
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-Aa-large.px-6.round-lg(
            @click="showMapAllDialog = false"
            color="info"
            depressed
            height=48
          ) Continue mapping
    y-dialog(
      v-if="showConfirmMappingDialog"
      v-model="showConfirmMappingDialog"
      max-width=568
      fluid
      scrollable
      content-class="round-2xl"
    )
      v-card
        v-card-text.pa-8.primary--text
          .text-xl.font-medium.mb-4 {{ checkedCount }} {{ checkedCount > 1 ? 'columns' : 'column' }}  will be imported. Another {{ totalCount - checkedCount }} columns will not be imported
          .text-md Are you sure you want to proceed?
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-Aa-large.px-6.round-lg.neutral500--text(
            @click="showConfirmMappingDialog = false"
            depressed
            height=48
            text
          ) No, I want to make changes
          v-btn.button-Aa-large.white--text.px-6.round-lg(
            @click="submitData"
            color="danger500"
            depressed
            height=48
          ) Yes, continue
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CustomFieldDropdown from '@/components/clinic/patient/CustomFieldDropdown.vue'
import TypeFieldDropdown from '@/components/module/upload/TypeFieldDropdown.vue'

export default {
  name: 'MapFields',
  components: {
    CustomFieldDropdown, 
    TypeFieldDropdown
  },
  props: ['data', 'inputFile'],
  data: () => ({
    checkAll: true,
    showMapAllDialog: false,
    showConfirmMappingDialog: false,
    isLoading: false,
    checkedCount: 0,
    totalCount: 0,
    headers: [
      {
        text: '',
        value: 'checked'
      },
      {
        text: 'Column',
        value: 'column'
      },
      {
        text: 'Sample Data',
        value: 'sample'
      },
      {
        text: 'Yezza Field',
        value: 'field'
      },
      {
        text: 'Type',
        value: 'type'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isUncheckedAll() {
      let uncheckedAll = true
      this.items.map(item => {
        if (item.checked) {
          uncheckedAll = false
        }
      })
      return uncheckedAll
    },
    selectedFields() {
      return this.items.filter(i => i.field).map(item => `${item.field.id}`)
    },
    items() {
      const fields = []
      if (this.data) {
        this.data.data.forEach(item => {
          const info = {
            checked: true,
            column: item[0],
            sample: item[1],
            field: null,
            type: null
          }
          fields.push(info)
        })
      }
      return fields
    }
  },
  created() {
    this.headers.map(item => item['class'] = 'text-table-header')
  },
  methods: {
    ...mapActions(['showMessage']),
    isTypeDisabled(item) {
      return item.field?.type !== 'User'
    },
    onCheckedAll(value) {
      this.items.map(item => item.checked = value)
    },
    onChecked(value) {
      if (!value) {
        this.checkAll = false
      }
    },
    finishMapping() {
      let isFieldEmpty = false
      this.items.map(item => {
        if (item.checked) {
          if (!item.field) {
            isFieldEmpty = true
          }
        }
      })
      if (isFieldEmpty) {
        this.showMapAllDialog = true
        return
      }
      const ids = this.items.filter(i => i.field).map(item => `${item.field.id}`.toLowerCase())
      if (ids.length !== new Set(ids).size) {
        this.showMessage(['error', 'Map only one field to a column'])
        return
      }

      this.checkedCount = this.items.filter(item => item.checked).length
      this.totalCount = this.items.length
      if (this.checkedCount !== this.totalCount) {
        this.showConfirmMappingDialog = true
      } else {
        this.submitData()
      }
    },
    submitData() {
      this.isLoading = true
      this.showConfirmMappingDialog = false
      const formData = new FormData()
      formData.append('file', this.inputFile)
      formData.append('header_row_index', 0)
      this.items.forEach((item, index) => {
        const mapperIndex = `mapper[${index}]`
        if (item.checked) {
          formData.append(`${mapperIndex}id`, `${item.field.id}`.toUpperCase())
          if (item.field?.datatype === 'date') {
            formData.append(`${mapperIndex}format`, 'DD/MM/YYYY')
          }
        } else {
          formData.append(mapperIndex, '')
        }
      })
      this.$axios.post(`/connect/${this.company.slug}/customers/import_csv/validate`, formData)
      .then(resp => {
        this.$emit('onMapping', formData)
        this.$emit('onValidate', resp.data)
      })
      .catch(e => {
        if (e?.response?.data?.non_field_errors?.length > 0) {
          this.showMessage(['error', e.response.data.non_field_errors[0]])
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>